import React from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { INLINES } from "@contentful/rich-text-types";

import "./biography.css";
import "./biographyMobile.css";

import BiographyToggle from "./biographyToggle";

// Options for rendering rich text from Contentful
const richTextOptions = {
  renderNode: {
    [INLINES.HYPERLINK]: (node, children) => (
      <a
        className="biography-link"
        href={node.data.uri}
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
      </a>
    ),
  },
};

// Experience column, newest first. `current` shows the pink marker.
// `companies` lists one company per line.
const experience = [
  { role: "Head of Brand", companies: ["FLORA"], years: "2026 — Present", current: true },
  { role: "Art Director", companies: ["Apple"], years: "2023 — 2026" },
  { role: "Co-Founder", companies: ["Moss"], years: "2020 — 2023" },
  { role: "Freelance Designer/AD", companies: [], years: "2019 — 2020" },
  { role: "Designer/Animator", companies: ["Gretel"], years: "2017 — 2019" },
];

export default class Biography extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: this.props.open };

    // This binding is necessary to make `this` work in the callback
    this.handleBiographyToggle = this.handleBiographyToggle.bind(this);
  }

  // handle state of biography being toggled
  handleBiographyToggle() {
    this.setState((state) => ({
      open: !state.open,
    }));
  }

  render() {
    return (
      <div>
        <div className={this.state.open ? "biography open" : "biography"}>
          <button
            className="biographyClose"
            onClick={this.handleBiographyToggle}
            aria-label="Close"
          >
            <svg viewBox="0 0 10 10" aria-hidden="true">
              <path d="M1 1L9 9M9 1L1 9" />
            </svg>
          </button>
          <div className="colophon body-font">
            <div className="copyright">
              &copy; Nick Miller {new Date().getFullYear()}
            </div>
          </div>
          <div className="columns">
            <section className="about body-font">
              <div className="story">
                {this.props.bio && this.props.bio.fields.content
                  ? documentToReactComponents(this.props.bio.fields.content, richTextOptions)
                  : <p>Bio content not found.</p>
                }
              </div>
            </section>
            <section className="experience body-font">
              <ul className="experience-list">
                {experience.map((job) => (
                  <li
                    key={`${job.role}-${job.years}`}
                    className={job.current ? "current" : undefined}
                  >
                    {job.role}
                    {job.companies.map((company) => (
                      <React.Fragment key={company}>
                        <br />
                        {company}
                      </React.Fragment>
                    ))}
                    <br />
                    {job.years}
                  </li>
                ))}
              </ul>
            </section>
            <section className="contact body-font">
              <ul className="contact-links">
                <li>
                  <a href="mailto:nick@nickmiller.tv">nick@nickmiller.tv</a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/in/nick-miller-8bb159a5/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    LinkedIn
                  </a>
                </li>
              </ul>
            </section>
          </div>
        </div>
        <BiographyToggle handleBiographyToggle={this.handleBiographyToggle} />
      </div>
    );
  }
}
